import { config } from "../env";
import {
  Delete,
  get,
  patch,
  patchFileUpload,
  post,
  postFileUpload,
} from "./helpers/http-handler";

export const getSupportList = (queryRequest: string) =>
  get(`${config.API_URL}/support?${queryRequest}`);

export const getSpecificSupportTicket = (id: string) =>
  get(`${config.API_URL}/support/${id}`);

export const createSupportTicket = (payload: object) =>
  post(`${config.API_URL}/support`, payload);

export const updateSupportTicket = (id: string, payload: object) =>
  patch(`${config.API_URL}/support/${id}`, payload);

export const deleteSupportTickets = (id: String) =>
  Delete(`${config.API_URL}/support/${id}`);

//Support - upload

export const uploadSupportTicket = (id: any, payload: any) =>
  patch(`${config.API_URL}/support/${id}/upload/document`, payload);

export const deleteSupportTicket = (id: any, deleteId: any) =>
  Delete(`${config.API_URL}/support/${id}/document/${deleteId}`);

// export

export const exportSupport = (payload: object) =>
  post(`${config.API_URL}/reports/export-support`, payload);
